export const SET_DATAPAGE= 'SET_DATAPAGE';
export const SET_LANGUAGE= 'SET_LANGUAGE';
export const ADD_LANGUAGE_VALUES = 'ADD_LANGUAGE_VALUES';
export const ADD_LANGUAGE_EXTRAS = 'ADD_LANGUAGE_EXTRAS';
export const ADD_COUNT_DATAPAGE= 'ADD_COUNT_DATAPAGE';

export const set_datapage = (change) => {
    return {
        type: SET_DATAPAGE,
        payload: change
    }
}

export const SetLanguage = (change) => {
    return {
        type: SET_LANGUAGE,
        payload: change
    }
}

export const AddLanguageValues = (change) => {
    return {
        type: ADD_LANGUAGE_VALUES,
        payload: change
    }
}
export const AddLanguageExtras = (change) => {
    return {
        type: ADD_LANGUAGE_EXTRAS,
        payload: change
    }
}
export const AddCountDataPage = (change = true) => {
    return {
        type: ADD_COUNT_DATAPAGE,
        payload: change
    }
}
export const AddLanguage = (change) => {
    return {
        type: 'ADD_LANGUAGE',
        payload: change
    }
}

export const GetLanguage = (change) => {
    return {
        type: 'GET_LANGUAGE',
        payload: change
    }
}


export function getLanguage (state) {
    return {
        language: (value, valdefault = '') => {
            let t = state.language.variables.content[value]
            if (t) {
                return t
            }
            return valdefault ? valdefault : `${value}`
        },
        countDataPage: state.DataPageReducer.countChange
    }
}